import { useContext } from 'react';

import classNames from 'classnames';

import styles from './Menu.module.css';
import { ActivationContext } from '../../../../activation/Activation';
import { buildQueryString } from '../../../../Buyer/utils/queryParams';
import { LinkWithQuery } from '../../../LinkWithQuery/LinkWithQuery';
import { loansDashboardItem } from '../../SellerNavBar/links';
import {
  NavBarLinks,
  getResourcesLinks,
} from '../../SellerNavBar/SellerNavBar.helpers';

export const MenuDropdown = ({ isOpen }: { isOpen: boolean }) => {
  const { isOnboarded } = useContext(ActivationContext);
  const navBarLinks = NavBarLinks(isOnboarded);
  const resourcesLinks = getResourcesLinks(isOnboarded);

  const newTabProps = {
    target: '_blank',
    rel: 'noopener noreferrer',
  };

  return (
    <div
      data-testid="menuDropdown"
      className={classNames(
        styles.DropdownNavigation,
        isOpen ? styles.navigationOpen : styles.navigationClosed,
      )}
    >
      <div className={styles.navigationContainer}>
        <div className={styles.navItemSection}>
          <span className={styles.navItemSectionHeader}>Menu</span>
          {navBarLinks.map((navBarItem) => {
            const props = {
              key: navBarItem.label,
              ...(navBarItem.opensNewTab && newTabProps),
            };
            const classes = classNames(
              styles.dropdownNavLink,
              styles.mobileMenuItems,
              navBarItem.className ? styles[navBarItem.className] : '',
            );
            return navBarItem.isExternalLink ? (
              <a {...props} href={navBarItem.link} className={classes}>
                {navBarItem.label}
              </a>
            ) : (
              <LinkWithQuery
                {...props}
                to={navBarItem.link}
                className={classes}
              >
                {navBarItem.label}
              </LinkWithQuery>
            );
          })}
          {resourcesLinks.map((navBarItem) => {
            const props = {
              key: navBarItem.label,
              ...(navBarItem.opensNewTab && newTabProps),
            };
            const classes = classNames(
              navBarItem.className,
              styles.dropdownNavLink,
            );
            return navBarItem.isExternalLink ? (
              <a {...props} href={navBarItem.link} className={classes}>
                {navBarItem.label}
              </a>
            ) : (
              <LinkWithQuery
                {...props}
                to={navBarItem.link}
                className={classes}
              >
                {navBarItem.label}
              </LinkWithQuery>
            );
          })}
          <a
            className={classNames(
              styles.dropdownNavLink,
              styles.switchDashboards,
            )}
            data-testid="menuLoansDashboard"
            href={`${loansDashboardItem.link}${buildQueryString()}`}
            data-ga-id="navbar__switch"
          >
            {loansDashboardItem.label}
          </a>
        </div>
        <div className={styles.navItemSection}>
          <span className={styles.navItemSectionHeader}>Account</span>
          <a
            href="/my_account/logout/"
            className={classNames(styles.dropdownNavLink, styles.logout)}
          >
            Logout
          </a>
        </div>
      </div>
    </div>
  );
};
